import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-change-password',
  templateUrl: './default-change-password.component.html',
  styleUrls: ['./default-change-password.component.css']
})
export class DefaultChangePasswordComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
